import { Button, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { useState } from 'react';
import { useRenameMe } from '../api/coordinators';
import { useLogout } from './useLogout';

/**
 * Asks a login for its full name. `required` is the first-login form: it
 * cannot be closed without a name, so it carries its own "Odjava" — it covers
 * the user menu, which is the only other way out.
 */
export function NameDialog({
  current,
  required,
  onClose,
}: {
  current: string;
  required: boolean;
  onClose?: () => void;
}) {
  const [name, setName] = useState(current);
  const rename = useRenameMe();
  const logout = useLogout();
  const trimmed = name.trim();
  const save = () => {
    if (!trimmed) return;
    rename.mutate(trimmed, { onSuccess: () => onClose?.() });
  };

  return (
    <Modal
      opened
      onClose={() => (required ? undefined : onClose?.())}
      withCloseButton={!required}
      closeOnEscape={!required}
      closeOnClickOutside={!required}
      size="sm"
      title={required ? 'Kako ti je ime?' : 'Moje ime'}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          save();
        }}
      >
        <Stack gap={12}>
          <Text size="sm" c="dimmed">
            {required
              ? 'Ime podpisuje pošto prostovoljcem in stoji ob vsem, kar narediš: v Dnevniku, v niti Sporočil in pri označenih prihodih.'
              : 'Novo ime velja povsod, tudi pri starejših vpisih v Dnevniku.'}
          </Text>
          <TextInput
            id="coordinator-full-name"
            label="Ime in priimek"
            placeholder="npr. Nina Kranjc"
            autoComplete="name"
            data-autofocus
            maxLength={200}
            value={name}
            onChange={(e) => setName(e.currentTarget.value)}
          />
          <Group justify="space-between">
            {required ? (
              <Button size="compact-sm" variant="subtle" color="gray" onClick={logout}>
                Odjava
              </Button>
            ) : (
              <span />
            )}
            <Group gap={8}>
              {required ? null : (
                <Button size="compact-sm" variant="default" onClick={onClose}>
                  Prekliči
                </Button>
              )}
              <Button
                size="compact-sm"
                type="submit"
                disabled={!trimmed || trimmed === current.trim()}
                loading={rename.isPending}
              >
                Shrani
              </Button>
            </Group>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
